import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Navbar from '../components/Navbar';
import './Set.css';

const Set = () => {
  const navigate = useNavigate();
  const [avatar, setAvatar] = useState('');
  const [nickname, setNickname] = useState('');
  const [signature, setSignature] = useState('');
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [showCropper, setShowCropper] = useState(false);
  const [cropperImageUrl, setCropperImageUrl] = useState('');

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const result = await homeApi.getUserInfo();
      if (result.code === 200) {
        const userInfo = result.data.userinfo;
        setAvatar(userInfo.avatar || '');
        setNickname(userInfo.nickname || '');
        setSignature(userInfo.dec || '');
      }
    } catch (error) {
      console.error('获取用户信息失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // 检查文件类型
    if (!file.type.startsWith('image/')) {
      alert('请选择图片文件');
      return;
    }

    // 检查文件大小（限制 5MB）
    if (file.size > 5 * 1024 * 1024) {
      alert('图片大小不能超过 5MB');
      return;
    }

    // 读取文件用于预览
    const reader = new FileReader();
    reader.onload = (e) => {
      setCropperImageUrl(e.target.result);
      setShowCropper(true);
    };
    reader.readAsDataURL(file);
  };

  const handleCropperComplete = (croppedImage) => {
    setAvatar(croppedImage);
    setShowCropper(false);
  };

  const handleUploadAvatar = async () => {
    if (!cropperImageUrl) {
      saveUserInfo();
      return;
    }

    try {
      setUploading(true);

      // 将 base64 转换为 File 对象
      const response = await fetch(cropperImageUrl);
      const blob = await response.blob();
      const file = new File([blob], 'avatar.jpg', { type: 'image/jpeg' });

      const formData = new FormData();
      formData.append('file', file);

      const result = await homeApi.uploadFile(formData);

      if (result.code === 1) {
        setAvatar(result.data.fullurl);
        saveUserInfo(result.data.file);
      } else {
        alert(result.msg || '上传失败');
      }
    } catch (error) {
      console.error('上传头像失败:', error);
      alert('上传失败');
    } finally {
      setUploading(false);
    }
  };

  const saveUserInfo = async (avatarFile = null) => {
    if (!nickname.trim()) {
      alert('请输入昵称');
      return;
    }

    try {
      setLoading(true);

      const data = {
        nickname: nickname.trim(),
        dec: signature.trim()
      };

      if (avatarFile) {
        data.avatar = avatarFile;
      }

      const result = await homeApi.updateUserInfo(data);

      if (result.code === 200) {
        // 更新本地存储的用户信息
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        userInfo.nickname = nickname.trim();
        userInfo.dec = signature.trim();
        if (avatarFile) {
          userInfo.avatar = avatar;
        }
        localStorage.setItem('userInfo', JSON.stringify(userInfo));

        alert('修改成功');
        navigate('/profile');
      } else {
        alert(result.msg || '修改失败');
      }
    } catch (error) {
      console.error('保存用户信息失败:', error);
      alert('保存失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    if (cropperImageUrl) {
      handleUploadAvatar();
    } else {
      saveUserInfo();
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div className="set-page">
      <Navbar title="资料修改" />

      <div className="set-container">
        <div className="avatar-section" onClick={() => document.getElementById('avatar-input').click()}>
          <div className="avatar-wrapper">
            <div className="avatar-pic">
              <div 
                className="avatar-image"
                style={{ backgroundImage: `url(${avatar || '/avatar.jpg'})` }}
              ></div>
            </div>
          </div>
        </div>
        <input
          id="avatar-input"
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleImageSelect}
        />

        <div className="form-group">
          <div className="form-label">
            昵称<span className="required">*</span>
          </div>
          <div className="form-input-wrapper">
            <input
              type="text"
              placeholder="给自己取号好听的名字吧"
              maxLength={10}
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              className="form-input"
            />
          </div>
        </div>

        <div className="form-group">
          <div className="form-label">
            签名<span className="required">*</span>
          </div>
          <div className="form-input-wrapper">
            <textarea
              placeholder="写点有意思的签名吧(100字以内)"
              maxLength={100}
              value={signature}
              onChange={(e) => setSignature(e.target.value)}
              className="form-textarea"
              rows={4}
            />
          </div>
        </div>

        <button 
          className="submit-btn" 
          onClick={handleSave}
          disabled={uploading}
        >
          {uploading ? '上传中...' : '保存'}
        </button>
      </div>

      {showCropper && (
        <div className="cropper-overlay" onClick={() => setShowCropper(false)}>
          <div className="cropper-content" onClick={(e) => e.stopPropagation()}>
            <div className="cropper-header">
              <button onClick={() => setShowCropper(false)}>取消</button>
              <span>裁剪头像</span>
              <button onClick={() => handleCropperComplete(cropperImageUrl)}>确定</button>
            </div>
            <div className="cropper-preview">
              <img src={cropperImageUrl} alt="preview" className="preview-image" />
            </div>
          </div>
        </div>
      )}
      
      <BottomNav activeTab="profile" />
    </div>
  );
};

export default Set;
